import { render, staticRenderFns } from "./BottomItem.vue?vue&type=template&id=36e9b29c&scoped=true&"
import script from "./BottomItem.vue?vue&type=script&lang=js&"
export * from "./BottomItem.vue?vue&type=script&lang=js&"
import style0 from "./BottomItem.vue?vue&type=style&index=0&id=36e9b29c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e9b29c",
  null
  
)

export default component.exports